import React from "react";
import { Button, Card, Group, Stack, Text, Tooltip } from "@mantine/core";
import { IconExternalLink, IconMail } from "@tabler/icons-react";
import type { RewardDetail } from "@/utils/api/referrals";
import { getRewardStatusBadge, getRewardTypeDisplay } from "../utils";
import { handleViewReward } from "../utils/rewardHandlers";

interface RewardCardProps {
  reward: RewardDetail;
}

/**
 * Component for displaying a single reward card with status and actions
 */
export const RewardCard: React.FC<RewardCardProps> = ({ reward }) => {
  const isEmailDelivery = reward.deliveryMethod === "EMAIL";
  const canGenerateLink = reward.deliveryMethod === "LINK" && reward.rewardId;

  return (
    <Card key={reward.id} withBorder p="sm" radius="sm">
      <Group justify="space-between" wrap="nowrap">
        <Stack gap="xs" style={{ flex: 1 }}>
          {getRewardStatusBadge(reward.status)}
          <Text size="lg" fw={700} c="teal">
            ${reward.amount.toFixed(2)}
          </Text>
          <Text size="xs" c="dimmed">
            {getRewardTypeDisplay(reward.type)}
          </Text>
          {reward.createdAt && (
            <Text size="xs" c="dimmed">
              {new Date(reward.createdAt).toLocaleDateString()}
            </Text>
          )}
        </Stack>
        {isEmailDelivery ? (
          <Tooltip label="Reward sent via email" position="left">
            <Button
              variant="light"
              size="xs"
              color="blue"
              leftSection={<IconMail size={14} />}
              disabled
            >
              Email
            </Button>
          </Tooltip>
        ) : canGenerateLink ? (
          <Button
            onClick={() => handleViewReward(reward.rewardId!, reward.id)}
            variant="light"
            size="xs"
            leftSection={<IconExternalLink size={14} />}
          >
            View
          </Button>
        ) : null}
      </Group>
    </Card>
  );
};
